export default __webpack_public_path__ + "static/gift-card-valentine-a0fb8a5bcc58736960381ac63712f8dc.jpg";